function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["className", "style", "source", "isOpen", "onClose", "onErrorCallback", "onDownload", "Loading", "pdfName", "documentClassName", "pageClassName", "download"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { isMobile } from '@fe-util/common';
import classNames from 'classnames';
import { Icon, Loading as IronLoading } from "./..";
import React, { memo, useEffect, useRef, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import Dropdown from "./components/DropDown";
import PageSelector from "./components/PageSelector";
import "./index.less";
import { base64ToBlob, calculate, isAndroid, isBase64 } from "./utils/utils";
// pdfjs.GlobalWorkerOptions.workerSrc = `https://cdn.bootcdn.net/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js`
// pdfjs.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.js";

pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/legacy/build/pdf.worker.min.js',
//@ts-ignore
import.meta.url).toString();
var PDFReader = /*#__PURE__*/memo(function (props) {
  var className = props.className,
    style = props.style,
    source = props.source,
    isOpen = props.isOpen,
    onClose = props.onClose,
    onErrorCallback = props.onErrorCallback,
    onDownload = props.onDownload,
    Loading = props.Loading,
    pdfName = props.pdfName,
    documentClassName = props.documentClassName,
    pageClassName = props.pageClassName,
    _props$download = props.download,
    download = _props$download === void 0 ? {
      isShow: true,
      element: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
        name: "tray-arrow-d"
      }), "Save")
    } : _props$download,
    restProps = _objectWithoutProperties(props, _excluded);
  var classes = classNames('iron-pdf-preview-modal-overlay', className);
  var pageClassNames = classNames('iron-pdf-page-container', pageClassName);
  var documentClassNames = classNames('iron-pdf-document-style', documentClassName);
  var width = isMobile() ? window.screen.width * 0.8 : 800;
  var _useState = useState(1),
    _useState2 = _slicedToArray(_useState, 2),
    scale = _useState2[0],
    setScale = _useState2[1];
  var _useState3 = useState(1),
    _useState4 = _slicedToArray(_useState3, 2),
    percent = _useState4[0],
    setPercent = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    numPages = _useState6[0],
    setNumPages = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isModalOpen = _useState8[0],
    setIsModalOpen = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isPercent = _useState10[0],
    setIsPercent = _useState10[1];
  // const [pdfData, setPdfData] = useState<any>();

  var percentClassNames = classNames('iron-bottom-percent animate__animated', {
    animate__fadeIn: isPercent,
    animate__fadeOut: isPercent === false
  });
  var pdfContainerRef = useRef(null);
  useEffect(function () {
    setIsModalOpen(isOpen);
    if (isOpen) {
      document.body.style.overflow = 'hidden'; // 禁止滚动
    } else {
      document.body.style.overflow = 'auto'; // 恢复滚动
    }
    // 清理函数：组件卸载时恢复页面滚动
    return function () {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);
  var onDocumentLoadSuccess = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(document) {
      var numPages;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            // TODO 这里是否能直接拿到PDF 的数据，这样下载是都走的base64 下载统一行为。
            numPages = document.numPages; // try {
            //   const data = await document.saveDocument();
            //   // this.downloadManager.download(data, this._downloadUrl, this._docFilename);
            //   console.log(data);
            //   setPdfData(data);
            // } catch (reason) {
            //   // When the PDF document isn't ready, fallback to a "regular" download.
            //   console.error(`Error when saving the document:`, reason);
            // }
            setNumPages(numPages);
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onDocumentLoadSuccess(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var onDocumentLoadError = function onDocumentLoadError(e) {
    if (typeof onErrorCallback === 'function') {
      onErrorCallback(e);
    }
  };
  var onPageZoomIn = function onPageZoomIn() {
    if (scale >= 10) return;
    var result = calculate(scale, 0.2, 'plus');
    setScale(result);
    setPercent(result);
    setIsPercent(true);
    setTimeout(function () {
      setIsPercent(false);
    }, 1000);
  };
  var onPageZoomOut = function onPageZoomOut() {
    if (scale <= 0) return;
    var result = calculate(scale, 0.2, 'minus');
    setScale(result);
    setPercent(result);
    setIsPercent(true);
    setTimeout(function () {
      setIsPercent(false);
    }, 1000);
  };
  var onSelectPercent = function onSelectPercent(val) {
    var _val$split;
    var selectVal = val === null || val === void 0 || (_val$split = val.split('%')) === null || _val$split === void 0 ? void 0 : _val$split[0];
    var result = calculate(selectVal, 100, 'div');
    setScale(result);
    setPercent(result);
  };

  // 滚动到指定页面
  var scrollToPage = function scrollToPage(page) {
    if (pdfContainerRef.current) {
      var pageElements = pdfContainerRef.current.querySelectorAll('.react-pdf__Page');
      if (page >= 1 && page <= pageElements.length) {
        var targetPage = pageElements[page - 1];
        targetPage.scrollIntoView({
          block: 'start'
        });
      }
    }
  };

  // const saveFile = (file: any, fileName: any) => {
  //   console.log(file);
  //   const aLink = document.createElement('a');
  //   aLink.href = file;
  //   aLink.style.display = 'none';
  //   aLink.setAttribute('download', 'fileName');
  //   aLink.download = fileName;
  //   document.body.appendChild(aLink);
  //   aLink.click();
  // };

  // const arrayBufferToBlob = (
  //   buffer: ArrayBuffer,
  //   mimeType: string = 'application/pdf',
  // ): Blob => {
  //   return new Blob([buffer], { type: mimeType });
  // };

  // const readArrayBufferWithFileReader = (arrayBuffer: ArrayBuffer) => {
  //   const blob = arrayBufferToBlob(arrayBuffer);
  //   const reader = new FileReader();

  //   reader.onload = (event) => {
  //     const result = event.target?.result;
  //     // 在此处处理读取结果，例如进行下载或显示
  //     console.log('FileReader 读取结果:', result);

  //     // 如果需要下载，可以创建隐藏的 <a> 标签并触发点击
  //     const docName = 'downloaded_file.pdf'; // 下载后的文件名
  //     const aLink = document.createElement('a');
  //     aLink.style.display = 'none';
  //     aLink.download = docName;
  //     const url = window.URL.createObjectURL(blob);
  //     aLink.href = url;
  //     document.body.appendChild(aLink);
  //     aLink.click();
  //     document.body.removeChild(aLink); // 移除 DOM 元素
  //     window.URL.revokeObjectURL(url); // 释放 URL 对象
  //   };

  //   reader.onerror = (error) => {
  //     console.error('FileReader 读取错误:', error);
  //   };

  //   // 读取 ArrayBuffer 内容为 ArrayBuffer（保持原样）
  //   reader.readAsArrayBuffer(blob);
  // };

  var toDownloadPdf = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var docName, aLink, blob, url;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (source) {
              docName = pdfName ? "".concat(pdfName, ".pdf") : 'downloaded_file.pdf'; // 下载后的文件名
              if (onDownload) {
                onDownload(source, docName);
              } else {
                // @ts-ignore :安卓手机内置对象 不用申明,为了兼容Android mobile app, 直接发送base64 给安卓原生处理
                if (isAndroid() && typeof Android !== 'undefined' && isBase64(source)) {
                  // @ts-ignore :安卓手机内置对象 不用申明
                  Android.bcMobileHandler(JSON.stringify({
                    docName: docName,
                    fileContent: source
                  }));
                  console.log('call Android.bcMobileHandler', docName);
                  // } else if (isIOSAPP() && isBase64(source)) {
                  // TODO 需要给iOS原生处理下载逻辑
                } else {
                  // readArrayBufferWithFileReader(pdfData);
                  aLink = document.createElement('a');
                  aLink.style.display = 'none';
                  aLink.download = docName;
                  if (isBase64(source)) {
                    blob = base64ToBlob(source);
                    url = window.URL.createObjectURL(blob);
                    aLink.href = url;
                  } else {
                    aLink.href = source;
                  }
                  document.body.appendChild(aLink);
                  aLink.click();
                  document.body.removeChild(aLink); // remove dom
                  window.URL.revokeObjectURL(source); // remove blob
                }
              }
            }
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function toDownloadPdf() {
      return _ref2.apply(this, arguments);
    };
  }();
  if (!isModalOpen) return null;
  var options = ['50%', '75%', '100%', '125%', '150%', '200%', '300%', '400%'];
  var formatPercent = calculate(percent, 100, 'times');
  return /*#__PURE__*/React.createElement("div", {
    className: classes,
    style: style
  }, /*#__PURE__*/React.createElement("div", {
    className: "iron-pdf-preview-modal",
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "iron-pdf-top-bar"
  }, /*#__PURE__*/React.createElement("div", {
    className: "iron-pdf-preview-modal-pagination"
  }, /*#__PURE__*/React.createElement(PageSelector, {
    scrollPage: scrollToPage,
    num: numPages
  })), /*#__PURE__*/React.createElement("div", {
    className: "iron-pdf-zoom-style"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: onPageZoomOut,
    className: "iron-pdf-zoom-button",
    type: "button"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "circle-minus"
  })), /*#__PURE__*/React.createElement("div", {
    className: "iron-pdf-zoom-percent-wrapper"
  }, /*#__PURE__*/React.createElement("span", {
    className: "iron-pdf-zoom-percent"
  }, formatPercent, "%"), /*#__PURE__*/React.createElement(Dropdown, {
    options: options,
    defaultValue: '100%',
    onSelectOption: onSelectPercent
  })), /*#__PURE__*/React.createElement("button", {
    onClick: onPageZoomIn,
    className: "iron-pdf-zoom-button",
    type: "button"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "circle-plus"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "iron-pdf-preview-modal-action"
  }, download && download.isShow && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "iron-pdf-preview-modal-download",
    onClick: toDownloadPdf
  }, download.element), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "iron-pdf-preview-modal-close",
    onClick: onClose
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "cross"
  })))), /*#__PURE__*/React.createElement("div", {
    className: 'iron-pdf-wrapper'
  }, /*#__PURE__*/React.createElement("div", {
    className: "iron-pdf-container",
    ref: pdfContainerRef
  }, /*#__PURE__*/React.createElement(Document, {
    file: isBase64(source) ? base64ToBlob(source) : source,
    onLoadSuccess: onDocumentLoadSuccess,
    onLoadError: onDocumentLoadError,
    loading: Loading ? /*#__PURE__*/React.createElement("div", {
      className: "pdf-loading-container"
    }, Loading) : /*#__PURE__*/React.createElement("div", {
      className: "pdf-loading-container"
    }, /*#__PURE__*/React.createElement(IronLoading, null)),
    className: documentClassNames
  }, new Array(numPages).fill('').map(function (item, index) {
    return /*#__PURE__*/React.createElement(Page, _extends({
      pageNumber: index + 1,
      width: width,
      key: index,
      scale: scale,
      className: pageClassNames
    }, restProps));
  }))))), /*#__PURE__*/React.createElement("div", {
    className: percentClassNames
  }, formatPercent, "%"));
});
export default PDFReader;